module.exports = __webpack_public_path__ + "img/vertical_3_1_6005.a52b2b63.png";